// extracted by mini-css-extract-plugin
export default {"wrapper":"intentionsOver_wrapper__jJZ2b","image":"intentionsOver_image__be6SK","inside":"intentionsOver_inside__0n5by"};